// Build a download filename that is always recognised as audio by the OS.
// Some records (e.g. АТС call recordings) come with a human-readable `FileName`
// that has no extension ("Звонок 6 мин. 40 сек."), while the real extension is
// carried separately in `Extension`. Using `FileName` as-is would save a file
// with no extension, so it opens as a "broken" format. This guarantees the
// correct extension is always present.
export const buildAudioDownloadName = (
  fileName: string | null | undefined,
  extension: string | null | undefined,
  fallbackBase: string
): string => {
  const ext =
    (extension ?? '').trim().toLowerCase().replace(/^\./, '') || 'mp3';
  const name = (fileName ?? '').trim();

  if (!name) return `${fallbackBase}.${ext}`;
  if (name.toLowerCase().endsWith(`.${ext}`)) return name;

  // Strip trailing dots before appending so "Звонок 6 мин. 40 сек." becomes
  // "Звонок 6 мин. 40 сек.mp3" rather than "...сек..mp3".
  return `${name.replace(/\.+$/, '')}.${ext}`;
};

export const getMimeTypeByName = (fileName: string): string => {
  const ext = fileName.split('.').pop()?.toLowerCase() ?? '';

  switch (ext) {
    case 'jpg':
    case 'jpeg':
      return 'image/jpeg';
    case 'png':
      return 'image/png';
    case 'gif':
      return 'image/gif';
    case 'pdf':
      return 'application/pdf';
    case 'txt':
      return 'text/plain';
    case 'csv':
      return 'text/csv';
    case 'json':
      return 'application/json';
    default:
      return 'application/octet-stream';
  }
};
